import { render, staticRenderFns } from "./tutorForm.vue?vue&type=template&id=fa014fda&scoped=true"
import script from "./tutorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tutorForm.vue?vue&type=style&index=0&id=fa014fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa014fda",
  null
  
)

export default component.exports